var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.55446C1 2.38448 1 1.79948 1.24405 1.47701C1.45666 1.19609 1.78163 1.02225 2.13341 1.00125C2.53721 0.977151 3.02416 1.30165 3.99807 1.95063L16.6719 10.3962C17.4766 10.9324 17.879 11.2006 18.0192 11.5385C18.1418 11.834 18.1418 12.166 18.0192 12.4615C17.879 12.7994 17.4766 13.0676 16.6719 13.6038L3.99807 22.0494C3.02416 22.6984 2.53721 23.0228 2.13341 22.9987C1.78163 22.9778 1.45666 22.8039 1.24405 22.523C1 22.2005 1 21.6155 1 20.4455V3.55446Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/playIcon.b83c14eb064773b953a8e258ffc19547.svg";
export { ForwardRef as ReactComponent };